import { useTonConnectUI } from "@tonconnect/ui-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainHeaderStore from "../../../../stores/MainHeaderStore";

interface Props {
  store: MainHeaderStore;
  lockBodyScroll: () => void;
  unlockBodyScroll: () => void;
}

const useMobMenu = ({ store, lockBodyScroll, unlockBodyScroll }: Props) => {
  const [tonConnectUI] = useTonConnectUI();
  const navigate = useNavigate();
  const logoutClick = () => {
    tonConnectUI?.disconnect();
    store.setIsMenuMobOpen(false);
  };
  const closeMenu = () => {
    store.setIsMenuMobOpen(false);
  };
  const navigateToLendings = () => {
    navigate(`/lendings`);
  };
  useEffect(() => {
    if (store.isMenuMobOpen) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  }, [store.isMenuMobOpen]);
  return { logoutClick, closeMenu, navigateToLendings };
};

export default useMobMenu;
